<template>
  <p class="sectionTitle mb-2">－最新のお知らせ－</p>
  <v-card
    v-if="posts.length > 0"
    :subtitle="timestampToTime(posts[0].timestamp)"
  >
    <v-card-title v-if="posts[0].emergency != 'true'">{{
      posts[0].title
    }}</v-card-title>
    <v-card-title v-if="posts[0].emergency == 'true'" class="emergencyTitle"
      ><img
        src="../assets/emargency.png"
        alt="Emergency"
        class="emergencyIcon"
      />{{ posts[0].title }}</v-card-title
    >
    <v-card-text style="white-space: pre-line"
      >{{ posts[0].text }}
      <a
        :href="host + '/media/' + posts[0].mediaFile"
        target="_blank"
        v-if="posts[0].media == 'true'"
        ><img
          :src="host + '/media/' + posts[0].mediaFile"
          alt=""
          class="postImg mt-2"
      /></a>
    </v-card-text>
  </v-card>
  <v-divider class="mt-2 mb-2"></v-divider>
  <p class="sectionTitle mb-2">－過去のお知らせ－</p>
  <v-card
    ><v-card-text
      ><dl class="itemList">
        <template v-for="(item, index) in posts" :key="item.id">
          <dt v-show="index != 0">{{ timestampToTime(item.timestamp) }}</dt>
          <dd v-show="index != 0">
            {{ item.title }}<br />{{ makeShort(item.text) }}
            <v-btn class="ml-2" color="primary" @click="showDetail(index)"
              >詳細表示</v-btn
            >
          </dd>
          <v-divider class="mt-2 mb-2"></v-divider>
        </template>
      </dl> </v-card-text
  ></v-card>
  <v-overlay v-model="detailPanel">
    <v-card
      :title="posts[detailIndex].title"
      :subtitle="timestampToTime(posts[detailIndex].timestamp)"
      :text="posts[detailIndex].text"
      style="margin: 50vw 3vw 0 3vw"
    >
      <v-card-text
        ><v-row justify="end"
          ><v-btn color="primary" @click="detailPanel = false" class="mr-2 mb-2"
            >閉じる</v-btn
          ></v-row
        ></v-card-text
      >
    </v-card></v-overlay
  >
</template>

<script>
import Export from "../export";
import store from "../store";
export default {
  name: "DisplayPosts",
  props: {
    msg: String,
  },
  async mounted() {
    this.getPosts();
  },
  data() {
    return {
      detailPanel: false,
      detailIndex: 0,
    };
  },
  computed: {
    posts: {
      get() {
        return store.state.posts;
      },
      set(value) {
        store.state.posts = value;
      },
    },
    host: {
      get() {
        return store.state.host;
      },
      set(value) {
        store.state.host = value;
      },
    },
  },
  methods: {
    async getPosts() {
      var getPosts = await Export.getPosts();
      this.posts = getPosts.data;
      this.posts = this.posts.sort(function (a, b) {
        return a.timestamp > b.timestamp ? -1 : 1; //オブジェクトの降順ソート
      });
      for await (let item of this.posts) {
        if (item.media == "true") {
          var getMedia = await Export.getMedia(item.id);
          item.mediaFile = getMedia.data[0].name;
        }
      }
    },
    timestampToTime(timestamp) {
      var d = new Date(Number(timestamp));
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hour = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      var min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      var sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
      return (
        year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec
      );
    },
    makeShort(txt) {
      var st = txt.substr(0, 12);
      return st + "...";
    },
    replaceBr(txt) {
      var t = txt.replace(/\n/g, "<br />");
      return t;
    },
    showDetail(id) {
      this.detailPanel = true;
      this.detailIndex = id;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.v-card-text {
  font-size: 1rem !important;
}
.v-card-subtitle {
  font-size: 0.9rem !important;
}
.itemList dt {
  font-size: 0.9rem !important;
  color: #7a7a7a;
}
.itemList dd {
  font-size: 1rem !important;
}
.sectionTitle {
  color: #44bd3f;
  text-align: center;
}
.emergencyIcon {
  height: 26px;
  margin-right: 8px;
}
.v-card-title {
  font-weight: bold;
}
.emergencyTitle {
  color: #ff0000;
}
.postImg {
  width: 100%;
}
</style>
